import ChangePasswordPage from './ChangePasswordPage'
export { ChangePasswordPage }
export default ChangePasswordPage
